import React from 'react'

const CheckIcon = () => {
    return (
        <svg
            className="check-icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
        >
            <path
                d="M20 6L9 17l-5-5"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );

}

export default CheckIcon
